import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { StorageService } from '../storage/storage.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(
    private router: Router,
    private storage: StorageService
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const requestPath: string = request.url.replace(environment.api, '').split('?')[0]
    if (this.verifyIfRouteIsIgnored(requestPath)) {
      return next.handle(request)
    }
    if (!this.storage.loggedEmployee) {
      this.router.navigate(['/auth', 'login'])
      return of(null)
    }
    request = request.clone({
      setHeaders: { token: this.storage.loggedEmployee.token }
    })
    return next.handle(request)
  }

  private verifyIfRouteIsIgnored(requestPath: string): boolean {
    for (const ignoredRoute of ['/auth', '/register']) {
      if (requestPath.startsWith(ignoredRoute)) {
        return true
      }
    }
    return false
  }
}
